import { useAuthContext } from "../context/AuthContext"
export default function Profile(){
  const { currentUser } = useAuthContext()
  return (
    <>
      <h1 className="text-center" >Profile</h1>
      <hr style={{ width: "50%", margin: "3rem auto"}}/>
      <div className="d-flex justify-content-center align-items-center">
      <img style={{borderRadius:"10px"}} src={currentUser?.photoURL} width="150" height="150" alt=''/> 
        <ul className="list-group mx-5">
          <li className="list-group-item"><span className="fs-5">Name:</span> {currentUser?.displayName}</li>
          <li className="list-group-item"><span className="fs-5">Email:</span>{currentUser?.email}</li>
        </ul>
      </div>
    </>
  )
}